import gql from 'graphql-tag';
import { useRef } from 'react';
import className from 'classnames/bind';
import { TicketingFragment } from '@graphqlTypes';
import TicketingForm from './Form';
import { Container, RevealWrapper } from '@components';
import { getHighlightMarkup } from '@/core/utils';
import TicketingProvider from './TicketingProvider';
import { TicketPriceFragment } from '@/fragments/TicketPrice';

import { useViewSize } from '@/providers/ViewSizeContext';
import { useInView } from 'motion/react';
import { AnimVals } from '@/utils/animUtils';

import styles from './Ticketing.module.scss';
const cx = className.bind(styles);

const TicketingHeadline = ({ headline, size }: { headline: string; size: string; }) => {
  const Tag = size !== 'title-uc-xl' ? 'h2' : 'h1';
  const headlineMarkup = getHighlightMarkup(headline);
  return (
    <Tag
      className={cx(["headline", size])}
      dangerouslySetInnerHTML={{ __html: headlineMarkup }}
    />
  );
};

export default function Ticketing(props: TicketingFragment) {
  const { titleSize, headline, subhead, ticketingForm } = props;

  const { isDesktop } = useViewSize();
  const rootEl = useRef<HTMLDivElement>(null);
  const REVEAL = AnimVals;
  const triggerPercent = isDesktop ? REVEAL.lg.triggerPercent : REVEAL.sm.triggerPercent;
  const isInView = useInView(rootEl, { amount: triggerPercent, once: REVEAL.once });

  return (
    <section className={cx(["ticketing"])} ref={rootEl}>
      <RevealWrapper isInView={isInView}>
        <Container className={cx("ticketing__container")}>
          <div className={cx("ticketing__content")}>
            <div className={cx(["copy", "col-12", "col-lg-5"])}>
              <TicketingHeadline headline={headline} size={titleSize[0]} />
              <p className="text-l">{subhead}</p>
            </div>
            <TicketingProvider data={ticketingForm}>
              <TicketingForm {...ticketingForm} />
            </TicketingProvider>
          </div>
        </Container>
      </RevealWrapper>
    </section>
  )
}

Ticketing.fragments = {
  entry: gql`
    ${TicketPriceFragment}
    fragment Ticketing on FlexiblePageContentContentTicketingLayout {
      titleSize
      headline
      subhead
      ticketingForm {
        formVariant
        ctaLabel
        step1Label
        todayLabel
        tomorrowLabel
        anotherDateLabel
        step2Label
        step2Subtext
        infoEyebrow
        step3Label
        step3Subtext
        step3Tickets {
          nodes {
            ...Ticket
          }
        }
        discountedTickets {
          accordionLabel
          discountedTicket {
            node {
              ...Ticket
            }
          }
          ticketsIncluded {
            nodes {
              contentTypeName
              ...Ticket
            }
          }
        }
      }
    }
  `,
};